export default {
  getComments: (state) => state.comments,
  getFFComment: (state) => state.ffcomment,
  getSignatureComments: (state) => state.signaturecomments,
};
